import { Button, Col, DatePicker, Form, Row, TreeSelect } from 'antd';

import React, { useState } from 'react';

import MultiSelect from '../../../../components/common/MultiSelect';
import PageHeading from '../../../../components/common/PageHeading';
import RightBar from '../../../../components/common/RightBar';

import { Propertiesunitscampaigns } from '../../../../data/renewals';
import { reports } from '../reportData';

const BulkPropertyReportsRightBar = [];

function BulkPropertyReports() {
  const [value, setValue] = useState();
  const onChange = (newValue) => {
    console.log(newValue);
    setValue(newValue);
  };
  return (
    <>
    <div className='bulk-property-reports'>
      <PageHeading heading="Bulk Property Reports" />
      <Form labelCol={{ span: 5 }}
            wrapperCol={{ span: 11 }}
            colon={false}>
      <Row gutter={[0, 16]}>
        <Col span={24}>
          <p>Create an unconsolidated report packet with an individual report generated for each property.</p>
        </Col>
        <Col span={24}>
          <Form.Item label="Properties">
            <MultiSelect options={Propertiesunitscampaigns} placeholder="Search by property, group, portfolio or owner"/>
            <p className='silver-text'>By default all properties will be included.</p>
          </Form.Item>
          <Form.Item label="Report" required>
          <TreeSelect
      style={{
        width: '100%',
      }}
      value={value}
      dropdownStyle={{
        maxHeight: 400,
        overflow: 'auto',
      }}
      treeData={reports}
      placeholder="Start typing to search"
      treeDefaultExpandAll
      onChange={onChange}
    />
          </Form.Item>
          <Form.Item label="Date Range" required>
            <Row gutter={[24, 0]} align="middle">
              <Col><DatePicker /></Col>
              <Col>To</Col>
              <Col><DatePicker /></Col>
            </Row>
          </Form.Item>
        </Col>
        <Col span={24}>
          <Button type='primary'>Download Reports</Button>
        </Col>
      </Row>
      </Form>
    </div>
    <div className="RightSidebar">
      <RightBar RightBarData={BulkPropertyReportsRightBar} />
    </div>
    </>
  )
}

export default BulkPropertyReports;
